import script from "./price-table.vue?vue&type=script&setup=true&lang=js"
export * from "./price-table.vue?vue&type=script&setup=true&lang=js"

import "./price-table.vue?vue&type=style&index=0&id=0d9cf980&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9cf980"]])

export default __exports__